import { styled } from '@material-ui/core/styles';
import { Container, Grid, InputBase, Typography } from '@material-ui/core';

export const MainContainer = styled(Container)(({ theme }) => ({
	// Reason: typescript doesn't allow for custom classes on material-ui
	// @ts-ignore
	background: `radial-gradient(circle at 50%, ${theme.palette.custom.backgroundCircle}, ${theme.palette.background.default} 50%)`,
	[theme.breakpoints.up('md')]: {
		// @ts-ignore
		background: `radial-gradient(circle at 60%, ${theme.palette.custom.backgroundCircle}, ${theme.palette.background.default} 50%)`
	},
	[theme.breakpoints.down('sm')]: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		paddingLeft: 0,
		paddingRight: 0
	},
	height: '100%'
}));

export const PaperContainer = styled(Grid)(({ theme }) => ({
	paddingBottom: theme.spacing(6),
	justifyContent: 'center',
	display: 'flex'
}));

export const EndAlignText = styled(Typography)({
	textAlign: 'end'
});

export const BalanceGrid = styled(Grid)(({ theme }) => ({
	padding: theme.spacing(1, 0)
}));

export const BorderedFocusableContainerGrid = styled(Grid)(({ theme }) => ({
	border: '1px solid #5C5C5C',
	borderRadius: 8,
	padding: '18.5px 14px',
	'&:focus-within': {
		borderColor: theme.palette.primary.main
	}
}));

export const InputTokenActionButtonsGrid = styled(Grid)(({ theme }) => ({
	alignItems: 'center',
	justifyContent: 'flex-end',
	[theme.breakpoints.only('xs')]: {
		justifyContent: 'space-evenly'
	}
}));

export const InputTokenAmount = styled(InputBase)({
	fontSize: '3rem',
	fontWeight: 600,
	'&::-webkit-input-placeholder, &::-moz-placeholder, &:-ms-input-placeholder, &:-moz-placeholder': {
		color: '#afafaf'
	}
});
